import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, hydrationPending } = useAuthStore();

  if (hydrationPending) {
    // 로딩 상태를 표시하거나 아무것도 렌더링하지 않음
    return null;
  }

  if (!user) {
    // 인증되지 않은 사용자는 로그인 페이지로 리다이렉트
    return <Navigate to="/login" />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
